export const UnAuthorized = 'unauthorized';
export const PaymentRequired = 'payment-required';
export const CannotChangePlan = 'cannot-change-plan';
export const CannotPublishPage = 'cannot-publish-page';
